import Splide from "@splidejs/splide";

function initSliderStudioSpecialisation(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-studio-specialisation").forEach((el) => {
		const sliderStudioSpecialisation = new Splide(el, {
			mediaQuery: "min",
			perPage: 1.55,
			gap: "20px",
			pagination: true,
			arrows: true,
			snap: true,
			focus: "left",
			omitEnd: true,
			speed: 700,
			breakpoints: {
				640: { perPage: 2.5, gap: "20px" },
				768 : { perPage: 2.5, gap: "20px" },
				1024: { perPage: 4, gap: "30px", drag : false},
			},
		});

		sliderStudioSpecialisation.mount();
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderStudioSpecialisation());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-studio-specialisation", ($block) => {
		initSliderStudioSpecialisation($block && $block.jquery ? $block.get(0) : $block);
	});
}
